import { render, staticRenderFns } from "./addressManage.vue?vue&type=template&id=806e5f56&scoped=true"
import script from "./addressManage.vue?vue&type=script&lang=js"
export * from "./addressManage.vue?vue&type=script&lang=js"
import style0 from "./addressManage.vue?vue&type=style&index=0&id=806e5f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806e5f56",
  null
  
)

export default component.exports